import { usePlaybackIsPaused, usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { useCursor, useSetCursor } from '../../stores/stream-screen.store';

/**
 * Hook to shift the cursor.
 */

export function useShiftCursor() {
  const ts = useCursor();
  const setCursor = useSetCursor();
  const isPaused = usePlaybackIsPaused();
  const play = usePlaybackPlay();

  return (offset = 0) => {
    if (!ts) {
      return;
    }

    setCursor(ts + offset);

    if (isPaused) {
      play({
        startTs: ts + offset,
        playAfterSeek: false,
      });
    }
  };
}
